import Vue from 'vue'
import { launchdarklyKeys } from '@/utils/launchdarklyKeys'
import { evaluateRouteMeta } from '@/utils/routeFeatureFlagMeta'

const TRACKED_FLAG_KEYS = [...new Set(Object.values(launchdarklyKeys))]

const state = {
  ready: false,
  values: {},
  listenersBound: false,
}

const mutations = {
  setFeatureFlags(s, payload) {
    s.values = { ...payload }
  },
  setFeatureFlagsReady(s, ready) {
    s.ready = ready
  },
  setFeatureFlagsListenersBound(s, bound) {
    s.listenersBound = bound
  },
}

function readAll(client) {
  const next = {}
  for (const key of TRACKED_FLAG_KEYS) {
    next[key] = Boolean(client.variation(key, false))
  }
  return next
}

const actions = {
  bindLaunchDarklyClient({ commit, state }, client) {
    const sync = () => {
      commit('setFeatureFlags', readAll(client))
      commit('setFeatureFlagsReady', true)
    }

    if (!state.listenersBound) {
      commit('setFeatureFlagsListenersBound', true)
      for (const key of TRACKED_FLAG_KEYS) {
        client.on(`change:${key}`, sync)
      }
    }
    sync()
  },

  async ensureReady({ dispatch, state }) {
    if (state.ready) {
      return
    }
    const ld = Vue.prototype.$launchDarkly
    const client = await ld.getClient()
    await dispatch('bindLaunchDarklyClient', client)
  },
}

const getters = {
  flagValues: (s) => s.values,
  evaluateRouteRecord: (s) => (record) => evaluateRouteMeta(record.meta, s.values),
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
